import axiosInstance from "./axiosConfig";
import { Product } from "../models/product";

// Types for cart
export interface CartItem {
  product?: Product | null;
  enclosure?: any | null; // Replace 'any' with your Enclosure type if available
  quantity: number;
  _id?: string;
}

export interface CartResponse {
  id: string;
  user: {
    id: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    email: string;
    statementEmails?: string[];
    phone?: string;
    emailVerified?: boolean;
    address?: any;
  };
  items: CartItem[];
  subTotal: number;
  tax: number | string;
  deliveryFee: number;
}

export interface CartRequest {
  productId: string;
  quantity: number;
}

export const cartService = {
  // Get cart contents
  getCart: async (): Promise<CartResponse> => {
    try {
      const response = await axiosInstance.get('/cart');
      return response.data.data;
    } catch (error) {
      console.error("Error fetching cart:", error);
      throw error;
    }
  },

  // Add item to cart
  addToCart: async (productId: string, quantity: number = 1): Promise<CartResponse> => {
    try {
      const response = await axiosInstance.post('/cart', { productId, quantity });
      return response.data.data;
    } catch (error) {
      console.error("Error adding to cart:", error);
      throw error;
    }
  },

  // Update cart item quantity
  updateCartItem: async (productId: string, quantity: number): Promise<CartResponse> => {
    try {
      const response = await axiosInstance.put('/cart', { productId, quantity });
      return response.data.data;
    } catch (error) {
      console.error("Error updating cart:", error);
      throw error;
    }
  },

  // Remove item from cart
  removeFromCart: async (productId: string): Promise<CartResponse> => {
    try {
      const response = await axiosInstance.delete(`/cart/remove/${productId}`);
      return response.data.data;
    } catch (error) {
      console.error("Error removing from cart:", error);
      throw error;
    }
  },

  // Clear entire cart
  clearCart: async (): Promise<CartResponse> => {
    try {
      const response = await axiosInstance.delete('/cart/clear');
      return response.data.data;
    } catch (error) {
      console.error("Error clearing cart:", error);
      throw error;
    }
  }
}; 